const deleteFileFromFileList = (fileList, idToDelete) => {
  return fileList.filter( file => file.uid !== idToDelete);
}

export default deleteFileFromFileList;